import React, {useState, useEffect, useRef, useMemo} from 'react'
import { Modal} from '@bedrock/components'
import classNames from 'classnames/bind'
import styles from './index.less'
import {SupplierNameList} from "#features/SupplierName";

const cx = classNames.bind(styles)

type ErrorSupplierProps = {
  message: string
  suppliers: any[]
}
export default function openErrorSupplierModel(props: ErrorSupplierProps) {
  const {suppliers, message} = props
  // 如果msg中有 \n 则替换为 <br/>
  const showMsg = message?.split?.('\n')?.map?.((item, index) => {
    return <span key={index}>{item}<br/></span>
  }) || '';
  Modal.error({
    title: showMsg,
    mask: true,
    width: 400,
    okText: '知道了',
    okCancel: false,
    centered: true,
    content: (
      <div>
        {
          !!suppliers?.length && <SupplierNameList suppliers={suppliers} nameKey={'supplier_name'}/>
        }
      </div>
    ),
  })
}
